import { Vehicle } from '../../../lib/App';

export interface FilterResult {
  input: string[];
  notExists: string[];
}

export const selectRecordsFromPage = (
  fromPage: number,
  toPage: number,
  items: any[],
  RECORD_PER_PAGE: number,
): any[] => {
  const res: any[] = [];
  for (
    let index = fromPage * RECORD_PER_PAGE;
    index < toPage * RECORD_PER_PAGE;
    index++
  ) {
    if (index >= items.length || index < 0) {
      break;
    }
    res.push(items[index]);
  }
  return res;
};

export const extractInput = (
  searchInput: string,
  vehiclesMap: Map<number, Vehicle>,
): FilterResult => {
  searchInput = searchInput.replace(/\s+/g, '');
  const inputVehicleIds = searchInput.split(',');
  const notExists: any[] = [];
  const input: any[] = [];
  inputVehicleIds.forEach((id) => {
    const idNum = parseInt(id, 10);
    if (isNaN(idNum)) {
      return;
    }
    if (!vehiclesMap.has(idNum)) {
      notExists.push(id);
      return;
    }
    input.push(id);
  });
  return {
    input,
    notExists,
  };
};
